/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentRealtorName', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-realtor-name',
        replace: true,
        scope: {
          formObj: "=",
          formScope: "=",
          isRequired: '=?'
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {}]
      };

    }]);
}());